import { render, staticRenderFns } from "./ProgramaRecompensaHistoricoMovimentacao.vue?vue&type=template&id=b9d72ace&scoped=true&"
import script from "./ProgramaRecompensaHistoricoMovimentacao.vue?vue&type=script&lang=js&"
export * from "./ProgramaRecompensaHistoricoMovimentacao.vue?vue&type=script&lang=js&"
import style0 from "./ProgramaRecompensaHistoricoMovimentacao.vue?vue&type=style&index=0&id=b9d72ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d72ace",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTooltip})
